import { useFormattedCountdown } from '@openeducation/oe-it-hooks';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';

import { TimerItem } from './timer-item';

export interface CountdownContainerProps {
  msToNextClassBegin?: number;
}

export const CountdownContainer = ({
  msToNextClassBegin,
}: CountdownContainerProps) => {
  const { hours, minutes, seconds } = useFormattedCountdown({
    timeoutMs: msToNextClassBegin,
    enabled: true,
    loop: false,
  });

  return (
    <TimerContainer>
      <TimerItem label="hours" value={hours} />
      <TimerItem label="minutes" value={minutes} />
      <TimerItem label="seconds" value={seconds} />
    </TimerContainer>
  );
};

const TimerContainer = styled.View`
  flex-direction: row;
  margin-top: 8px;
  gap: 8px;
`;
